import { useState, useEffect, useCallback } from 'react';

import useFetch from 'use-http';

import { API_ROUTES } from '../../constants';

import {
    TIntendedUsers,
    TAPIResponseIntendedUsers,
} from './application-intended-users.types';

type TUseAPIFetchIntendedUsersOptions = {
  silence?: boolean;
};

export const useAPIFetchIntendedUsers = (
  options?: TUseAPIFetchIntendedUsersOptions
): TAPIResponseIntendedUsers => {
  const { get, response, loading, error } = useFetch(API_ROUTES.ATTRIBUTES);

  const [intendedUsers, setintendedUsers] = useState<TIntendedUsers[] | []>([]);

  const fetchIntendedUsers = useCallback(async (): Promise<void> => {
    const { data } = await get('/app_intented_usr?include_only_active=true');
    setintendedUsers(data ? data.items : []);
  }, [get]);

  useEffect(() => {
    if (!options?.silence) {
     fetchIntendedUsers();
    }
    // eslint-disable-next-line
  }, []);
  return {
    data: intendedUsers,
    loading,
    loaded: response.ok,
    error,
    fetchIntendedUsers,
  };
};
